import Table from 'src/components/common/tables';
import { TableHeader } from 'src/components/common/tables/TableHeader';
import { TableRow } from 'src/components/common/tables/TableRow';
import { TableCell } from 'src/components/common/tables/TableCell';
import { Button } from '@habitech/call-to-action';
import Form from '../Form';
import { GridContainer } from 'src/components/common/grids/GridContainer';
import { GridItem } from 'src/components/common/grids/GridItem';
import { Checkbox } from '@habitech/selectors';
import { useOrphanAssigment } from '../hooks/useOrphanAssigment.hook';
import { ButtonWrapper, ResponsiveWrapper, TableCellStyled, TableContainer, TableWrapper, Title } from '../styles';
import Loading from 'src/components/common/Loading/Loading';
import ModalComponent from '../modal/modalComponent';
import { EmptyData } from 'src/components/NoData/emptyData';


const SearchByEmail = () => {
  const {
    handleSearch,
    handleCheckbox,
    loading,
    saving,
    propertyTypes,
    transactionTypes,
    propertyTypesConfig,
    transactionTypeConfig,
    prices,
    locations,
    showCarouselTable,
    purpose,
    type_childrens,
    modalState,
    carousels,
    showTables,
    showEmptyData,
    handleSaveConfiguration,
    handleAnalyze,
    closeModal
  } = useOrphanAssigment();

  return (
    <ResponsiveWrapper>
      <Title>Búsqueda de propiedades por correo del broker</Title>
      <Form type="users" loadingList={loading} handleSearch={handleSearch} />
      {loading && !showTables && <Loading data-testid="loading" height={"300px"} />}
      {showEmptyData && <EmptyData />}
      {!showEmptyData && showTables && <><div style={{ position: 'relative' }}>
        <GridContainer style={{ marginTop: 16, marginBottom: 16 }}>
          <GridItem md={8} lg={12} style={{ minWidth: 320 }}>
            <TableContainer className="center">
              <Title>Tipo de propiedad</Title>
              <Table>
                <thead>
                  <TableRow>
                    <TableHeader>{ }</TableHeader>
                    <TableHeader>Configuración actual</TableHeader>
                    <TableHeader>Inventario actual</TableHeader>
                    <TableHeader>Seleccionar</TableHeader>
                  </TableRow>
                </thead>
                <tbody>
                  {propertyTypes.map((item, idx) => (
                    <TableRow key={item.label}>
                      <TableCellStyled className='left'>
                        <TableCell>{item.label}</TableCell>
                      </TableCellStyled>
                      <TableCellStyled className='center'>
                        <TableCell>
                          <Checkbox
                            name='type'
                            originType='pcom'
                            selected={type_childrens?.includes(item.type_children)}
                            dataId={`propertyType-${idx}`}
                            id={`propertyType-config-${idx}`}
                            value={`propertyType-${idx}`}
                            disabled
                          />
                        </TableCell>
                      </TableCellStyled>
                      <TableCell>{item.count}</TableCell>
                      <TableCellStyled className='center'>
                        <TableCell>
                          <Checkbox
                            name='type'
                            originType='pcom'
                            selected={item.configuration}
                            dataId={`propertyType-select-${idx}`}
                            id={`propertyType-select-${idx}`}
                            value={`propertyType-${idx}`}
                            onChange={() => handleCheckbox('propertyType', item.type_children)}
                          />
                        </TableCell>
                      </TableCellStyled>
                    </TableRow>
                  ))}
                  <TableRow>
                    <TableCellStyled className='left'>
                      <TableCell><b>Total</b></TableCell>
                    </TableCellStyled>
                    <TableCellStyled className='center'>
                      <TableCell>{""}</TableCell>
                    </TableCellStyled>
                    <TableCell><b>{propertyTypes.reduce((acc, item) => acc + (item.count || 0), 0)}</b></TableCell>
                    <TableCellStyled className='center'>
                      <TableCell>{""}</TableCell>
                    </TableCellStyled>
                  </TableRow>
                </tbody>
              </Table>
            </TableContainer>
          </GridItem>
          <GridItem md={8} lg={12} style={{ minWidth: 320 }}>
            <TableContainer className="center">
              <Title>Tipo de transacción</Title>
              <Table loading={loading}>
                <thead>
                  <TableRow>
                    <TableHeader>{ }</TableHeader>
                    <TableHeader>Configuración actual</TableHeader>
                    <TableHeader>Inventario actual</TableHeader>
                    <TableHeader>Inventario filtrado</TableHeader>
                    <TableHeader>Seleccionar</TableHeader>
                  </TableRow>
                </thead>
                <tbody>
                  {transactionTypes.map((item, idx) => (
                    <TableRow key={item.label}>
                      <TableCellStyled className='left'>
                        <TableCell>{item.label}</TableCell>
                      </TableCellStyled>
                      <TableCellStyled className='center'>
                        <TableCell>
                          <Checkbox
                            name='type'
                            originType='pcom'
                            selected={purpose?.includes(item.purpose)}
                            dataId={`transactionType-config-${idx}`}
                            id={`transactionType-config-${idx}`}
                            value={`transactionType-${idx}`}
                            disabled
                          />
                        </TableCell>
                      </TableCellStyled>
                      <TableCell>{item.count}</TableCell>
                      <TableCell>{item.countFiltered}</TableCell>
                      <TableCellStyled className='center'>
                        <TableCell>
                          <Checkbox
                            name='type'
                            originType='pcom'
                            selected={item.configuration}
                            dataId={`transactionType-select-${idx}`}
                            id={`transactionType-select-${idx}`}
                            value={`transactionType-${idx}`}
                            onChange={() => handleCheckbox('transactionType', item.purpose)}
                          />
                        </TableCell>
                      </TableCellStyled>
                    </TableRow>
                  ))}
                  {/* Fila de suma total para Tipo de transacción */}
                  <TableRow>
                    <TableCellStyled className='left'>
                      <TableCell><b>Total</b></TableCell>
                    </TableCellStyled>
                    <TableCellStyled className='center'>
                      <TableCell>{""}</TableCell>
                    </TableCellStyled>
                    <TableCell><b>{transactionTypes.reduce((acc, item) => acc + (item.count || 0), 0)}</b></TableCell>
                    <TableCell><b>{transactionTypes.reduce((acc, item) => acc + (item.countFiltered || 0), 0)}</b></TableCell>
                    <TableCellStyled className='center'>
                      <TableCell>{""}</TableCell>
                    </TableCellStyled>
                  </TableRow>
                </tbody>
              </Table>
            </TableContainer>
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem md={8} lg={12} style={{ minWidth: 320 }}>
            <TableContainer className="center">
              <Title>Precio</Title>
              <Table loading={loading}>
                <thead>
                  <TableRow>
                    <TableHeader>{ }</TableHeader>
                    <TableHeader>Rango</TableHeader>
                    <TableHeader>Número de propiedades</TableHeader>
                    <TableHeader>Rango filtrado</TableHeader>
                    <TableHeader>Número propiedades filtradas</TableHeader>
                  </TableRow>
                </thead>
                <tbody>
                  {prices.map((item) => (
                    <TableRow key={item.transaction}>
                      <TableCell>{item.transaction}</TableCell>
                      <TableCell>{item.range}</TableCell>
                      <TableCell>{item.count}</TableCell>
                      <TableCell>{item.filteredRange}</TableCell>
                      <TableCell>{item.countFiltered}</TableCell>
                    </TableRow>
                  ))}
                  {/* Fila de suma total para Precio */}
                  <TableRow>
                    <TableCell><b>Total</b></TableCell>
                    <TableCell>{""}</TableCell>
                    <TableCell><b>{prices.reduce((acc, item) => acc + (item.count || 0), 0)}</b></TableCell>
                    <TableCell>{""}</TableCell>
                    <TableCell><b>{prices.reduce((acc, item) => acc + (item.countFiltered || 0), 0)}</b></TableCell>
                  </TableRow>
                </tbody>
              </Table>
            </TableContainer>
          </GridItem>
          <GridItem md={8} lg={12} style={{ minWidth: 320 }}>
            <TableContainer className="center table-sticky">
              <Title>Ubicación</Title>
              <TableWrapper>
                <Table loading={loading}>
                  <thead className='thead-sticky'>
                    <TableRow>
                      <TableHeader>Ubicación</TableHeader>
                      <TableHeader>Propiedades</TableHeader>
                    </TableRow>
                  </thead>
                  <tbody>
                    {locations.map((item) => (
                      <TableRow key={item.label}>
                        <TableCellStyled className='left'>
                          <TableCell>{item.label}</TableCell>
                        </TableCellStyled>
                        <TableCell>{item.count}</TableCell>
                      </TableRow>
                    ))}
                    <TableRow>
                      <TableCellStyled className='left'>
                        <TableCell><b>Total</b></TableCell>
                      </TableCellStyled>
                      <TableCell><b>{locations.reduce((acc, item) => acc + (item.count || 0), 0)}</b></TableCell>
                    </TableRow>
                  </tbody>
                </Table>
              </TableWrapper>
            </TableContainer>
          </GridItem>
        </GridContainer>
      </div>
        <ButtonWrapper>
          <Button
            loading={loading || saving}
            dataId="button-analyze"
            originType="pcom"
            size="large"
            onClick={handleAnalyze}
            disabled={transactionTypeConfig === "" || propertyTypesConfig === ""}
          >
            Construir carruseles
          </Button>
        </ButtonWrapper>
        {showCarouselTable && carousels.length === 0 && <TableContainer id={"carousel-table"}><EmptyData /></TableContainer>}
        {showCarouselTable && carousels.length > 0 && (
          <><TableContainer id={"carousel-table"}>
            <Title>Resumen de huérfanos de los filtros aplicados</Title>
            <Table>
              <thead>
                <TableRow>
                  <TableHeader>{ }</TableHeader>
                  <TableHeader>Número de carruseles posibles</TableHeader>
                  <TableHeader>Número de potenciales huérfanos</TableHeader>
                  <TableHeader>Número de zonas</TableHeader>
                </TableRow>
              </thead>
              <tbody>
                {carousels.map((carousel) => (
                  <TableRow key={carousel.carousel_type}>
                    <TableCell>{carousel.carousel_type}</TableCell>
                    <TableCellStyled className='center'><TableCell>{carousel.carousel_unique}</TableCell></TableCellStyled>
                    <TableCellStyled className='center'><TableCell>{carousel.orphan_number}</TableCell></TableCellStyled>
                    <TableCellStyled className='center'><TableCell>{carousel.zones_number}</TableCell></TableCellStyled>
                  </TableRow>
                ))}
              </tbody>
            </Table>
          </TableContainer>
            <ButtonWrapper>
              <Button
                loading={loading || saving}
                dataId="button-analyze"
                originType="pcom"
                size="large"
                onClick={handleSaveConfiguration}
              >
                Guardar configuración
              </Button>
            </ButtonWrapper>
          </>
        )}
      </>}

      <ModalComponent
        isOpen={modalState.isOpen}
        onClose={closeModal}
        type={modalState.type}
        title={modalState.title}
        message={modalState.message}
        onConfirm={modalState.onConfirm || undefined}
      />
    </ResponsiveWrapper>
  );
};

export default SearchByEmail;